// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1H5Fb","icon":"SortAdornment_icon__UhP_t","up":"SortAdornment_up__23CvA","down":"SortAdornment_down__3JLnq","active":"SortAdornment_active__SYhOt"};